const playButton = document.querySelector(".play-button");
if (playButton) {
  playButton.addEventListener('click', function(e) {
    _play(this.parentNode);
  });
  playButton.addEventListener('keyup', function(e) {
    if (e.key === 'Enter') {
      _play(this.parentNode);
    }
  });
};

/*
  Helpers
 */

function _play (poster) {
  poster.style.display = 'none';
  const video = poster.previousElementSibling;
  video.tabIndex = 0;
  video.play();
};

function _closeAllDropdowns (target) {
  const openDropdowns = target.querySelectorAll('.open');
  openDropdowns.forEach(dropdown => {
    _closeDropdown(dropdown.firstElementChild);
  })
};

function _closeDropdown (target) {
  const parent = target.parentElement;
  if (parent.classList.contains('open')) {
    parent.classList.toggle('open');
    target.nextElementSibling.style.display = '';
  }
};
